import { VersionHistoryLike } from '@/components/shared-components/VersionHistory'

export const isLatestVersion = (
  versionHistory: VersionHistoryLike[],
  version: number
) => {
  const maxVersion = versionHistory.reduce(
    (max, v) => Math.max(max, v.version),
    0
  )

  return maxVersion === version
}
